import React from "react";
import { FaArrowLeft } from "react-icons/fa";
import { agreementLabel, displayValue, formatBrl, formatDisplayDate } from "../helpers/partyDetailsHelper";

// Shared building blocks for the redesigned detail pages (Party, Matter, Coordinator client).
// Styles live in PartyDetails.css and are scoped under `.party-details`.

export const DetailField = ({ label, value, testId, flag, children }) => (
  <div className="party-field">
    <div className="party-field-label">{label}</div>
    <div className="party-field-value">
      {children ?? <span data-testid={testId}>{value}</span>}
      {flag}
    </div>
  </div>
);

export const DetailChip = ({ label, testId, children }) => (
  <li className={`party-chip${React.isValidElement(children) ? " is-link" : ""}`} data-testid={testId}>
    <span className="party-chip-label">{label}</span>
    {React.isValidElement(children) ? children : <span className="party-chip-value">{children}</span>}
  </li>
);

export const DetailsBackLink = ({ label, onClick }) => (
  <button type="button" className="party-back-link" onClick={onClick}>
    <FaArrowLeft aria-hidden="true" />
    <span>{label}</span>
  </button>
);

export const CompensationTable = ({ records, t, testId = "party-compensation-table" }) => (
  <table className="party-compensation-table" data-testid={testId}>
    <thead>
      <tr>
        <th scope="col">{t("clientDetails.party.agreement")}</th>
        <th scope="col">{t("clientDetails.compensation.agreementDate")}</th>
        <th scope="col">{t("clientDetails.party.type")}</th>
        <th scope="col" className="is-amount">{t("clientDetails.party.amount")}</th>
        <th scope="col">{t("clientDetails.compensation.paymentDate")}</th>
      </tr>
    </thead>
    <tbody>
      {records.map((record, index) => (
        <tr key={record.id || index}>
          <td data-label={t("clientDetails.party.agreement")} className="is-agreement">
            {agreementLabel(record, index, t)}
          </td>
          <td data-label={t("clientDetails.compensation.agreementDate")}>
            {formatDisplayDate(record.agreementDate)}
          </td>
          <td data-label={t("clientDetails.party.type")}>{displayValue(record.agreementType)}</td>
          <td data-label={t("clientDetails.party.amount")} className="is-amount">
            {formatBrl(record.paymentAmount)}
          </td>
          <td data-label={t("clientDetails.compensation.paymentDate")}>
            {formatDisplayDate(record.paymentDate)}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);
